
export default {
  methods: {
    refreshPage() {
      window.location.reload();
    }
  }
};
